import styled from "@emotion/styled";
import { PageLayout } from "../../shared/layouts/PageLayout";
import { adminDashboardBreadcrumbs } from "../../features/AdminDashboard/admin-dashboard-breadcrumbs";
import { useAdminGetSubscriptionOffers } from "@queries/subscription/useAdminGetSubscriptionOffers";
import { SubscriptionOffersList } from "@features/SubscriptionOffers/SubscriptionOffersList";

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1.5rem;
  width: 100%;
  position: relative;

  ${(p) => p.theme.media.mobileDown} {
    grid-template-columns: 1fr;
  }

  &[aria-disabled="true"] {
    pointer-events: none;
    opacity: 0.5;
    * {
      pointer-events: none;
    }
  }
`;

const breadcrumbs = {
  current: adminDashboardBreadcrumbs.subscriptionOffers,
  previous: [adminDashboardBreadcrumbs.dashboard],
};

export function SubscriptionOffersPage() {
  const query = useAdminGetSubscriptionOffers();

  return (
    <PageLayout breadcrumbs={breadcrumbs}>
      <Container aria-disabled={query.isLoading}>
        <SubscriptionOffersList
          subscriptionOffers={query.data?.offers ?? []}
          isLoadingSubscriptionOffers={query.isLoading}
        />
      </Container>
    </PageLayout>
  );
}
